import moment from 'moment'
import {
  FE_SHU_ENV
} from '@/utils/constant'
/**
 * 格式化日期：开始时间yy-mm-dd hh:mm:ss - 结束时间 hh:mm:ss
 */
export function formatDateTiemStartAndEnd(startDateTime, endDateTime) {
  // 1、格式化开始日期和日期
  // eslint-disable-next-line no-mixed-operators,no-param-reassign
  startDateTime = startDateTime && moment(startDateTime).format('YYYY-MM-DD HH:mm') || ''
  // eslint-disable-next-line no-param-reassign,no-mixed-operators
  endDateTime = endDateTime && moment(endDateTime).format('HH:mm') || ''
  // 2、开始日期和结束日期
  return `${startDateTime} - ${endDateTime}`
}

/**
 * 获取url中的code
 * @returns
 */
export function getUrlCode() {
  // 截取url中的code方法
  const url = location.search
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  return theRequest
}

export function isFeishu() {
  const UA = window.navigator.userAgent
  return UA.includes(FE_SHU_ENV)
}
// 显示导航栏
export function showNavBar() {
  return !isFeishu()
}
// 显示状态栏
export function showStatusBar() {
  return !isFeishu()
}

/**
 * 检测对象属性是否存在
 * @param obj
 * @param key
 * @returns {boolean}
 */
export function hasOwnPropertyObj(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
export function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}
export const isMobile = () => {
  return /(iPhone|iPad|iPod|iOS|Android|Linux armv8l|Linux armv7l|Linux aarch64)/i.test(navigator.platform)
}
export function replaceParamVal(paramName, replaceWith, isRefresh) {
  const oUrl = window.location.href.toString()
  if (paramName && replaceWith) {
    if (oUrl.indexOf(paramName + '=' + replaceWith) > 1) {
      return
    }
  }
  let nUrl
  if (oUrl.indexOf('&' + paramName + '=') > 0) {
    // eslint-disable-next-line no-eval
    const re = eval('/(&' + paramName + '=)([^&]*)/gi')
    nUrl = oUrl.replace(re, '&' + paramName + '=' + replaceWith)
  } else {
    if (oUrl.indexOf('?') > 0) {
      nUrl = oUrl + '&' + paramName + '=' + replaceWith
    } else {
      nUrl = oUrl + '?' + paramName + '=' + replaceWith
    }
  }
  // this.location = nUrl;
  if (isRefresh) {
    window.location.href = nUrl
  }
  const stateObject = { id: '' }
  const title = ''
  history.replaceState(stateObject, title, nUrl)
}
export const typeJSON = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        // 不是就返回false
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}
export function getFileNameFromUrl(url) {
  try {
    const u = decodeURIComponent(url)
    const matches = u.match(/([^/?#]+)\/?$/);
    return matches ? matches[1] : null;
  } catch (e) {
    return ''
  }
}
export function getFileExtension(filename) {
  if (!filename || typeof filename !== 'string') return null
  // 使用正则表达式匹配文件后缀名
  const matches = filename.match(/\.([^.]*)$/)
  // 返回匹配到的后缀名，如果没有匹配到，则返回null
  return matches ? matches[1] : null
}

export function getUrlParams(name) {
  let url = window.location.href
  const params = {}
  if (url.indexOf('?') !== -1) {
    if (url.indexOf('%3D') > -1 || url.indexOf('%') > -1) {
      url = decodeURIComponent(url)
    }
    const arr = url.split('?')
    arr.forEach(item => {
      let state = item
      if (state.indexOf('%3D') > -1 || state.indexOf('%') > -1) {
        state = decodeURIComponent(state)
      }
      const paramsStr = state.split('&')
      for (let i = 0; i < paramsStr.length; i++) {
        const list = paramsStr[i].split('=')
        params[list[0]] = decodeURIComponent(list[1])
      }
    })
  }
  if (name) {
    return params[name]
  }
  return params
}
